(function() {
  'use strict';

  angular
    .module('quiz.multipleChoice', [])
    .controller('MultipleChoiceCtrl', MultipleChoiceCtrl);

  MultipleChoiceCtrl.$inject = ['$scope', 'gettext'];

  function MultipleChoiceCtrl($scope, gettext) {
    // set to null so index 0 is not selected
    $scope.answerModel = null;
    $scope.answerClass = [];

    $scope.$watch('answerModel', function(newValue) {
      if (newValue === null || newValue === undefined)
        return;

      if ($scope.state.answerSubmitted)
        return;

      $scope.state.answerSelected = true;
      $scope.answer.selectedAnswer = newValue;
      $scope.storeSelectedAnswer();
    });

    $scope.$watch('state', function(newValue) {
      if (!newValue)
        return;

      if (!$scope.state.answerGraded) {
        // change styles here?
        return;
      }

      if ($scope.answerModel != $scope.answer.selectedAnswer)
        $scope.answerModel = $scope.answer.selectedAnswer;

      setAnswerClasses();
    });

    $scope.$watch('state.tryAgainRequested', function(newValue) {
      if (!newValue) return;
      randomizeAnswers();
      setAnswerClasses();
      $scope.answerModel = null;
    });

    $scope.$watch('state.showAnswersRequested', function(newValue) {
      setAnswerClasses();
    });

    function setAnswerClasses() {
      for (var i = 0; i < $scope.questionAnswers.length; i++) {
        $scope.answerClass[$scope.questionAnswers[i].id] = setClass($scope.questionAnswers[i]);
      }
    }

    function setClass(item) {
      if (!$scope.state.answerGraded)
        return '';
//        return item.id === $scope.answer.selectedAnswer ? 'radioSelected' : 'radioNotSelected';

      if ($scope.state.showAnswersRequested && item.id === $scope.question.correctAnswer) {
        return 'correct';
      }

      if (!$scope.state.showAnswersRequested && item.id === $scope.answer.selectedAnswer)
        return $scope.state.name === 'answerCorrect' ? 'correct' : 'incorrect';

      return 'answered';
    }

    // Helpers
    function randomizeAnswers() {
      var all = { id: 'all', answer: gettext('All of the above'), $id: 'Alloftheabove' };
      var none = { id: 'none', answer: gettext('None of the above'), $id: 'Noneoftheabove' };

      // indexOf doesn't work because of the added $$hashKey key
      var allIndex = getAnswerIndex(all);
      if (allIndex > -1) {
        $scope.questionAnswers.splice(allIndex, 1);
      }
      var noneIndex = getAnswerIndex(none);
      if (noneIndex > -1) {
        $scope.questionAnswers.splice(noneIndex, 1);
      }

      $scope.questionAnswers = _.shuffle($scope.questionAnswers);

      if ($scope.question.includeAllAbove)
        $scope.questionAnswers.push(all);
      if ($scope.question.includeNoneAbove)
        $scope.questionAnswers.push(none);

      // since we're randomizing the answers, write that back to the question itself
      $scope.question.answers = $scope.questionAnswers.concat();
    }

    function getAnswerIndex(answer) {
      var index = -1;
      for (var i = 0; i < $scope.questionAnswers.length && index === -1; i++) {
        if ($scope.questionAnswers[i].id != answer.id) continue;
        index = i;
      }
      return index;
    }
  }
})();
